import { TableV3FilterItem } from 'common/table/types/TableV3';
import { useFetchListTeams } from 'modules/candidate-profile/hooks/useFetchListTeams';
import { useToast } from 'services/toast/hooks';
import { ToastType } from 'services/toast/types';

// The Team filter's options, loaded when the filter opens so they are never stale.
export const useTeamFilterSearch = () => {
  const { fetchListTeams } = useFetchListTeams();
  const { showToast } = useToast();

  const searchTeams = async (query: string): Promise<TableV3FilterItem[]> => {
    try {
      const teams = await fetchListTeams();
      const term = query.trim().toLowerCase();

      return teams
        .filter(({ name }) => name.toLowerCase().includes(term))
        .map(({ id, name }) => ({ label: name, value: id }));
    } catch {
      showToast({ title: 'Failed to load teams', type: ToastType.Error });
      return [];
    }
  };

  return { searchTeams };
};
